export default "__VITE_ASSET__abc19440__"